<template>
<section class="content-section related-mod-apps">
  <h2>Explore Other WhatsApp Mods</h2>
  <ul class="related-mod-list">
    <li
      v-for="item in modAppLinks"
      :key="item.key"
      :class="{ 'is-active': item.key === currentKey }"
    >
      <router-link v-if="item.key !== currentKey" :to="item.href" class="mod-app-pill">
        <img class="mod-app-pill__icon" :src="item.icon" :alt="item.label" width="28" height="28">
        <span class="mod-app-pill__label">{{ item.label }}</span>
      </router-link>
      <span v-else class="mod-app-pill" aria-current="page">
        <img class="mod-app-pill__icon" :src="item.icon" :alt="item.label" width="28" height="28">
        <span class="mod-app-pill__label">{{ item.label }}</span>
      </span>
    </li>
  </ul>
</section>
</template>

<script>
import { modAppLinks } from '@/documents/gbwappsPages';

export default {
  name: 'RelatedModApps',
  props: {
    currentKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      modAppLinks,
    };
  },
};
</script>
